<!-- Whitelabeled loader for use in this app -->
<script setup lang="ts">
import { Loader } from "@toruslabs/vue-components/Loader";

import useDappStore from "@/store/dappStore";

const dappStore = useDappStore();
</script>

<template>
  <Loader :show-logo="dappStore.showLogo" :logo-light="dappStore.whiteLabelLogo.light" :logo-dark="dappStore.whiteLabelLogo.dark" />
</template>
